export const MAGIC_LINK_MAX_SYMBOLS = 45;
export const MAGIC_LINK_MAX_SYMBOLS_TRIMMED = 43;
